// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

export const scrollToFirstFormError = () => {
    const firstErrorElement = document.querySelector("[aria-invalid='true']");
    if (firstErrorElement) {
        const formFieldParent = firstErrorElement.closest("[class*='FormFieldStyle']");
        if (!formFieldParent) {
            return;
        }
        const { top } = formFieldParent.getBoundingClientRect();
        // XNG-Changes
        window.scrollTo({
            top: top + window.pageYOffset - 47, // 47 is coming from sticky header height
            left: 0,
            behavior: "smooth",
        });
    }
};
